<template>
  <img
    class="object-cover"
    src="@/assets/images/emojis/emoji-leaf.png"
  >
</template>